"use client";

import { useRouter } from "next/navigation";
import { useTheme } from "next-themes";
import { useShortcut } from "./useShortcut";

/**
 * Bindings whose action needs React.
 *
 * Most shortcuts are declared at module scope in bindings/, because everything
 * they touch is reachable from the editor passed in the context. Theme and
 * navigation are not — they live behind hooks. Rather than route them through
 * the event bus and add a listener at the other end, they register here through
 * `useShortcut`, which is what that hook is for.
 *
 * Mounted once, alongside ShortcutProvider and inside ThemeProvider.
 */
export function GlobalShortcuts() {
  const { resolvedTheme, setTheme } = useTheme();
  const router = useRouter();

  useShortcut({
    id: "global.toggleTheme",
    keys: "Mod+Shift+L",
    scope: "global",
    label: "Toggle dark mode",
    group: "Navigation",
    allowInInput: true,
    // resolvedTheme rather than theme: with "system" selected, `theme` is the
    // string "system" and there is nothing sensible to invert.
    run: () => setTheme(resolvedTheme === "dark" ? "light" : "dark"),
  });

  useShortcut({
    id: "global.back",
    keys: "Mod+[",
    scope: "global",
    label: "Go back",
    group: "Navigation",
    allowInInput: true,
    run: () => router.back(),
  });

  useShortcut({
    id: "global.forward",
    keys: "Mod+]",
    scope: "global",
    label: "Go forward",
    group: "Navigation",
    allowInInput: true,
    run: () => router.forward(),
  });

  return null;
}
